import React, { useEffect } from "react";
import { IoIosArrowBack } from 'react-icons/io';
import "../../style.css";
import { Card, Col, Form, Row, Button, TabContent, TabPane } from "reactstrap";
import Search from "./tabs/search";
import Register from "./tabs/register";
import { useSelector } from "react-redux";
import * as  convenioController from "../../controllers/convenioInstituicaoController";
import * as convenioActions from "../../store/modules/convenioInstituicao/actions";
import Breadcrumb from "../../components/breadcrumbs";

const ConvenioInstituicao = () => {

    const { item, copy, activeTab, seeRegister, permitions } = useSelector(state => state.convenioInstituicao);

    useEffect(() => {
        if(window.location.search !== ''){
            convenioActions.setActiveTab('Register')
        }else{
            convenioActions.setActiveTab('Search')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function saveItem() {
        if (item.id === "") {
            convenioController.create(item);
        } else {
            convenioController.update(item, copy);
        }
    }

    function changeTab(tab) {
        convenioActions.setActiveTab(tab);
        convenioActions.cleanRegister();
    }

    function seeRegisterF() {
        if (item.id !== "") {
            convenioActions.cleanRegister();
        }
        convenioActions.setSeeRegister(false);
    }

    return (
        <>
                <Col>
                    <Breadcrumb activeTab={activeTab} />
                    <Card>
                        <Form>
                            {
                                activeTab === "Search"
                                    ?
                                    permitions.criar && (
                                        <Col md={12}>
                                            <Row className="pt-2 pb-2">
                                                <Col md={8}>
                                                    <Button
                                                        onClick={() => changeTab("Register")}
                                                        style={{ width: "215px" }}
                                                        className='purpleButton'
                                                    >
                                                        Cadastrar Convênio Instituição
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Col>
                                    )
                                    :
                                    <Col className="pt-2 pb-2">
                                        <Button
                                            onClick={() => { changeTab("Search"); seeRegisterF() }}
                                            style={{ width: "150px", color: "white" }}
                                            className='purpleButton'>
                                            <IoIosArrowBack style={{ marginTop: '3px', float: 'left' }} /> Voltar
                                        </Button>
                                        {!seeRegister && <Button
                                            onClick={() => saveItem()}
                                            style={{ width: "242px", float: 'right' }}
                                            className="purpleButton"
                                        >
                                            Salvar Cadastro
                                                        </Button>}
                                    </Col>
                            }
                        </Form>
                    </Card>
                </Col>

                <TabContent style={{ width: "100%" }} activeTab={activeTab}>
                    <TabPane tabId="Search">
                        <br />
                        <Search />
                    </TabPane>
                    <TabPane tabId="Register">
                        <br />
                        <Register />
                    </TabPane>
                </TabContent>
        </>
    );
}

export default ConvenioInstituicao;